const waterCalculators = document.body.querySelectorAll(".js-water-calculator")

let isSubmitted = false
let isValid = false

const isEndOfRoute = (inputs) => {
  return inputs.some((input) => {
    if (
      input.dataset.hasEndRoute &&
      input.selectedOptions[0].dataset.endRoute
    ) {
      return true
    }
    return false
  })
}

const showEndRoute = (endRoute, results) => {
  results.style.display = "none"
  endRoute.style.display = "block"
}

const showEstimate = (endRoute, results) => {
  results.style.display = "block"
  endRoute.style.display = "none"
}

const onSubmit = async (event, container, form, selects) => {
  event.preventDefault()
  const showEndRouteMessage = isEndOfRoute(selects)
  const endRouteContainer = container.querySelector(".js-end-route-container")
  const outputResults = container.querySelector(".js-output-results")

  if (showEndRouteMessage) return showEndRoute(endRouteContainer, outputResults)

  const results = container.querySelector(".js-estimate-result")
  const formData = new FormData(form)

  try {
    const response = await fetch("/api/estimate", {
      method: "POST",
      body: formData,
    })

    if (response.ok) {
      const htmlContent = await response.text()
      results.outerHTML = htmlContent
      showEstimate(endRouteContainer, outputResults)
    } else {
      console.error("Error:", response.statusText)
    }
  } catch (error) {
    console.error("Error:", error)
  }
}

const onChange = (submit, selects) => {
  if (isSubmitted) return
  isValid = selects.every((select) => select.value.length > 0)
  submit.disabled = !isValid
}

function init() {
  waterCalculators.forEach((container) => {
    const form = container.querySelector("form")
    const selects = Array.from(form.querySelectorAll("select"))
    const submit = form.querySelector("button[type='submit']")

    form.addEventListener("submit", (event) =>
      onSubmit(event, container, form, selects)
    )
    form.addEventListener("change", () => onChange(submit, selects))
  })
}

export default init



// WEBPACK FOOTER //
// ./src/components/components/developers/water-calculator/water-calculator.js